import { customApiCall } from "utils/axios";

import type { EpcExtractResponse } from "../components/address-step/epc-modal/types";

import addBuildingUrls from "./urls";

export const extractEpcDocument = async (
  file: File,

  options?: {
    onUploadProgress?: (event: { percentage: number }) => void;

    signal?: AbortSignal;
  }
): Promise<EpcExtractResponse> => {
  const { onUploadProgress, signal } = options ?? {};

  return customApiCall.upload({
    data: { file },
    onUploadProgress,
    signal,
    url: addBuildingUrls.epcExtract(),
  });
};
